import React from 'react'

const Spinner = () => {
  return (
    <div className='lc-loader'>
      <div className='lc-loader__spinner' aria-label='Indlæser...'/>
    </div>
  )
}

export default Spinner
